'use strict';

import React, {Component} from 'react';

import {ExclamationTriangleFill} from "react-bootstrap-icons";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

class Unauthorized extends Component {

    render() {
        return (
            <>
                <div className="app-wrapper maintenance-mode">
                    <header role="banner">
                        <div className="app-header-container">
                            <div className="app-header d-flex bg-purple">
                                <a href="http://uw.edu" title="University of Washington Home">
                                    <div className="uw-patch">University of Washington</div>
                                    <div className="uw-wordmark">University of Washington</div>
                                </a>
                            </div>
                        </div>
                    </header>
                    <Container fluid>
                        <Row>
                            <Col>
                                <main
                                    role="main"
                                    className="content"
                                    id="main-content"
                                    style={{minHeight: "30rem", paddingLeft: "5rem", paddingRight: "5rem"}}>
                                    <h1 className="my-4">
                                        <ExclamationTriangleFill className="me-2" aria-hidden={true}/>
                                        Unauthorized
                                    </h1>
                                    <p>We apologize for the inconvenience, but you are not authorized to access this application. If you believe
                                        this to be an error, please contact the administrator at <a href="mailto:help@uw.edu">help@uw.edu</a></p>
                                </main>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <footer className="container-fluid app-footer">
                    <div className="d-md-flex align-items-md-start justify-content-md-between">
                        <div className="text-center text-md-start">
                            <ul className="list-inline">
                                <li className="mb-2 mb-md-0">
                                    <a href="https://itconnect.uw.edu/it-connect-home/question/" target="_blank">UW-IT Help</a>
                                </li>
                                <li className="mb-2 mb-md-0">
                                    <a href="https://itconnect.uw.edu/" target="_blank">IT Connect</a>
                                </li>
                                <li className="mb-2 mb-md-0">
                                    <a href="http://www.washington.edu/online/privacy" target="_blank">Privacy</a>
                                </li>
                                <li className="mb-2 mb-md-0">
                                    <a href="http://www.washington.edu/online/terms" target="_blank">Terms</a>
                                </li>
                            </ul>
                        </div>
                        <div className="text-center text-md-end mt-4 mt-md-0">
                            <ul className="list-inline">
                                <li className="mb-2 mb-md-0">&copy; {new Date().getFullYear()} <a href="http://www.washington.edu/" target="_blank">University of Washington</a></li>
                                <li className="mb-2 mb-md-0">Seattle, WA</li>
                            </ul>
                        </div>
                    </div>
                </footer>
            </>
        );
    }
}

export default Unauthorized;
